import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRouter from './components/AppRouter';
import { useGetCurrentQuery } from './store/api/usersApi';

function App() {

  const{isLoading, error, data: user} = useGetCurrentQuery()

  if(isLoading){
    return <div>Loading...</div>
  }
  else return (
    <BrowserRouter>
    <div className="App">
      <AppRouter/>
    </div>
    </BrowserRouter>

  );
}

export default App;
